module.exports = __webpack_public_path__ + "img/approve-gray.742fc76b.svg";